import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AuthService } from '../../services/auth.service';
import { catchError, map, of, switchMap } from 'rxjs';
import { AuthActions } from '../state/auth/auth.action-types';
import { UserActions } from '../state/user/user.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { UserSettingsActions } from '../state/user-settings/user-settings.actions';
import { LocalStorageKeys } from '../../consts/shared.const';
import { SessionStorageService, errMessage } from '@ui';
import { UserSettingsModels } from '@share-models';
import { OrganizationActions } from '../state/organization/organization.actions';
import { PermissionsActions } from '../state/permissions/premissions.actions';

export const startLoadRequiredData = createEffect(
  (
    actions$ = inject(Actions),
    sessionStorageService = inject(SessionStorageService),
  ) => {
    return actions$.pipe(
      ofType(AuthActions.startLoadRequiredData),
      switchMap(() => {
        const interfaceLanguage = sessionStorageService.getItem(
          LocalStorageKeys.LANGUAGE,
        );
        if (interfaceLanguage) {
          sessionStorageService.removeItem(LocalStorageKeys.LANGUAGE);
        }
        return [
          UserActions.getUserProfile(),
          UserSettingsActions.getMe({
            language: interfaceLanguage ?? UserSettingsModels.LANGUAGE.ENGLISH,
          }),
          OrganizationActions.getActiveOrganization(),
          OrganizationActions.getMyOrganizations(),
          PermissionsActions.getUserPermissions(),
        ];
      }),
    );
  },
  { functional: true },
);

export const socialLoginByCode = createEffect(
  (actions$ = inject(Actions), api = inject(AuthService)) => {
    return actions$.pipe(
      ofType(AuthActions.socialLoginByCode),
      switchMap(({ code }) =>
        api.socialLoginByCode(code).pipe(
          map((authResponse) =>
            UserActions.loginSuccess({
              data: {
                idToken: authResponse.id_token,
                accessToken: authResponse.access_token,
                expiredAt: authResponse.expires_in,
              },
            }),
          ),
          catchError((err: HttpErrorResponse) => {
            const msg = errMessage(err);
            return of(AuthActions.logout({ params: { msg } }));
          }),
        ),
      ),
    );
  },
  { functional: true },
);
